"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setBasketDetailsCookie = exports.setBasketCookie = void 0;
var _config = _interopRequireDefault(require("next/config"));
var _validators = require("../validators");
var _base = require("./base64");
var _formatBasicBasketDetails = require("./formatBasicBasketDetails");
var setBasketDetailsCookie = exports.setBasketDetailsCookie = function setBasketDetailsCookie(basket, reservationId) {
  var isBB = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (reservationId && (0, _validators.isStringValid)(reservationId)) {
    var basketToBeSet = (0, _formatBasicBasketDetails.formatBasicBasketDetails)(basket, reservationId, isBB);
    setBasketCookie(reservationId, basketToBeSet);
  }
};
var setBasketCookie = (reservationId, basket) => {
  var _getConfig;
  var {
    publicRuntimeConfig = {}
  } = (_getConfig = (0, _config.default)()) !== null && _getConfig !== void 0 ? _getConfig : {};
  var d = new Date();
  d.setTime(d.getTime() + 30 * 60 * 1000);
  var expires = 'expires='.concat(d.toUTCString());
  var value = (0, _base.encodeToBase64)(JSON.stringify(basket));
  var path = 'path=/';
  var domain = 'domain='.concat(publicRuntimeConfig.NEXT_PUBLIC_COOKIES_DOMAIN);
  document.cookie = "".concat(reservationId, "=").concat(value, ";").concat(expires, ";").concat(path, ";").concat(domain);
};
exports.setBasketCookie = setBasketCookie;